module.exports = __webpack_public_path__ + "static/img/gerente.f48914e3.jpg";